import { render, staticRenderFns } from "./final-plat-date.vue?vue&type=template&id=422598af"
import script from "./final-plat-date.vue?vue&type=script&lang=js"
export * from "./final-plat-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports